export const links = [
    {
        title: "Home",
        href: "/"
    },
    {
        title: "Portfolio",
        href: "/projects"
    },
    {
        title: "Services",
        href: "/services"
    },
    {
        title: "About Us",
        href: "/aboutus"
    },
    {
        title: "Blog",
        href: "/blog"
    },
    {
        title: "Careers",
        href: "/careers"
    },
    {
        title: "Contact",
        href: "/contactus"
    }
]

export const footerLinks = [
    {
        title: "LinkedIn",
    },
    {
        title: "Instagram",
    },
    {
        title: "Feverr",
    },
    {
        title: "Behance",
    },
    {
        title: "Dribble",
    },
];
